import { useState, useMemo } from "react";
import { motion } from "framer-motion";
import { Search, Calendar, ShieldCheck, FileText, Download, Sparkles, AlertTriangle } from "lucide-react";
import PageHeader from "@/components/shared/PageHeader";
import StatCard from "@/components/shared/StatCard";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { RFPS } from "@/data/mockData";
import { Dashboard } from "../components/Rfp/Dashboard";
import { GovernmentOpportunities } from "../components/Rfp/GovernmentOpportunities";

const CATEGORIES = ["All", "Federal", "Education", "Healthcare", "Utilities", "Transportation"];
const TABS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "opportunities", label: "Government Opportunities" },
];

export default function RFPIntel() {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");
  const [selected, setSelected] = useState(RFPS[0]);
  const [activeTab, setActiveTab] = useState("dashboard");

  const list = useMemo(
    () =>
      RFPS.filter(
        (r) =>
          (cat === "All" || r.category === cat) &&
          (q === "" ||
            r.title.toLowerCase().includes(q.toLowerCase()) ||
            r.agency.toLowerCase().includes(q.toLowerCase()))
      ),
    [q, cat]
  );

  return (
    // <div data-testid="rfp-page">
    //   <PageHeader
    //     eyebrow="Module 03 · Government RFP Intelligence"
    //     title="Federal, state, city, county — indexed by AI."
    //     description="Continuously monitor procurement portals, extract budgets, deadlines and certifications, and auto-draft compliant proposals."
    //     actions={
    //       <Button data-testid="rfp-add-source" className="rounded-full bg-indigo-500 hover:bg-indigo-400">
    //         <Sparkles className="h-3.5 w-3.5 mr-1.5" /> Draft with AI
    //       </Button>
    //     }
    //   />

    //   <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
    //     <StatCard testId="rfp-stat-active" label="Active RFPs" value="24" delta="+6" accent="indigo" icon={FileText} />
    //     <StatCard testId="rfp-stat-closing" label="Closing < 7 days" value="5" delta="+1" accent="pink" icon={AlertTriangle} />
    //     <StatCard testId="rfp-stat-highbudget" label="High-Budget (>$1M)" value="9" delta="+2" accent="amber" />
    //     <StatCard testId="rfp-stat-qualified" label="Qualified" value="14" delta="+4" accent="emerald" icon={ShieldCheck} />
    //     <StatCard testId="rfp-stat-drafts" label="Proposals in Draft" value="6" delta="+2" accent="cyan" />
    //   </div>

    //   <div className="glass-card p-3 flex flex-col md:flex-row md:items-center gap-3 mb-4">
    //     <div className="flex items-center gap-2 flex-1 rounded-lg border border-white/[0.06] bg-white/[0.02] px-3">
    //       <Search className="h-4 w-4 text-white/40" />
    //       <Input
    //         data-testid="rfp-search"
    //         value={q}
    //         onChange={(e) => setQ(e.target.value)}
    //         placeholder="Search RFP title or agency…"
    //         className="border-0 bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 h-10 text-sm"
    //       />
    //     </div>
    //     <div className="flex items-center gap-1 rounded-full border border-white/[0.06] bg-white/[0.02] px-1 py-1">
    //       {CATEGORIES.map((c) => (
    //         <button
    //           key={c}
    //           onClick={() => setCat(c)}
    //           data-testid={`rfp-filter-${c.toLowerCase()}`}
    //           className={`text-[12px] px-2.5 py-1 rounded-full transition-colors ${cat === c ? "bg-white/[0.08] text-white" : "text-white/50 hover:text-white"
    //             }`}
    //         >
    //           {c}
    //         </button>
    //       ))}
    //     </div>
    //   </div>

    //   <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
    //     <div className="lg:col-span-3 space-y-3">
    //       {list.map((r, i) => (
    //         <motion.button
    //           key={r.id}
    //           initial={{ opacity: 0, y: 6 }}
    //           animate={{ opacity: 1, y: 0 }}
    //           transition={{ delay: 0.03 * i, duration: 0.25 }}
    //           onClick={() => setSelected(r)}
    //           data-testid={`rfp-card-${r.id}`}
    //           className={`glass-card p-5 text-left w-full hover:translate-y-[-2px] transition-transform ${selected?.id === r.id ? "!border-indigo-400/40 shadow-[0_0_0_1px_rgba(94,106,210,0.35)]" : ""
    //             }`}
    //         >
    //           <div className="flex items-center justify-between gap-3 mb-2">
    //             <Badge className="rounded-full bg-white/[0.05] border border-white/[0.08] text-white/70 font-mono text-[10px] uppercase tracking-wider hover:bg-white/[0.05]">
    //               {r.category}
    //             </Badge>
    //             <DeadlineChip days={r.daysLeft} />
    //           </div>
    //           <div className="font-display text-lg text-white leading-tight">{r.title}</div>
    //           <div className="text-[13px] text-white/50 mt-0.5">{r.agency}</div>
    //           <div className="mt-4 flex items-center justify-between">
    //             <div className="font-mono text-cyan-300 text-sm">{r.budget}</div>
    //             <div className="flex items-center gap-2">
    //               <span className="text-[11px] font-mono text-white/40">Score</span>
    //               <ScoreBar value={r.score} />
    //               <span className="font-mono text-[13px] text-white">{r.score}</span>
    //             </div>
    //           </div>
    //         </motion.button>
    //       ))}
    //     </div>

    //     <div className="lg:col-span-2">
    //       {selected && (
    //         <div className="glass-card p-6 sticky top-24" data-testid="rfp-detail-panel">
    //           <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-wider text-white/50 mb-3">
    //             <Calendar className="h-3.5 w-3.5" />
    //             Closes {selected.closes}
    //           </div>
    //           <div className="font-display text-2xl text-white leading-tight">{selected.title}</div>
    //           <div className="text-[13px] text-white/60 mt-1">{selected.agency}</div>

    //           <div className="grid grid-cols-2 gap-3 mt-5">
    //             <MiniCell label="Budget" value={selected.budget} />
    //             <MiniCell label="Docs" value={`${selected.docs} files`} />
    //             <MiniCell label="Score" value={`${selected.score}/100`} />
    //             <MiniCell label="Status" value={selected.status} />
    //           </div>

    //           <div className="mt-5">
    //             <div className="font-mono text-[10px] uppercase tracking-wider text-white/50 mb-2">Required certifications</div>
    //             <div className="flex flex-wrap gap-1.5">
    //               {selected.certs.length ? selected.certs.map((c) => (
    //                 <span key={c} className="text-[11px] rounded-full border border-emerald-500/20 bg-emerald-500/10 text-emerald-300 px-2 py-0.5 font-mono">
    //                   <ShieldCheck className="inline h-2.5 w-2.5 mr-1 -mt-0.5" /> {c}
    //                 </span>
    //               )) : <span className="text-white/40 text-xs">None specified</span>}
    //             </div>
    //           </div>

    //           <div className="mt-5">
    //             <div className="font-mono text-[10px] uppercase tracking-wider text-white/50 mb-2">AI summary</div>
    //             <p className="text-[13.5px] leading-relaxed text-white/75">
    //               This procurement seeks a partner to modernize legacy systems with a cloud-native platform, integrate with existing state directories and provide a 24-month rollout. Base2Brand qualifies on 8/10 technical criteria; one certification gap remains.
    //             </p>
    //           </div>

    //           <div className="mt-5 flex flex-col gap-2">
    //             <Button data-testid="rfp-draft-btn" className="rounded-full bg-indigo-500 hover:bg-indigo-400 w-full">
    //               <Sparkles className="h-3.5 w-3.5 mr-1.5" /> Generate proposal draft
    //             </Button>
    //             <Button variant="ghost" className="rounded-full text-white/70 hover:text-white w-full border border-white/[0.06]">
    //               <Download className="h-3.5 w-3.5 mr-1.5" /> Download attachments
    //             </Button>
    //           </div>
    //         </div>
    //       )}
    //     </div>
    //   </div>
    // </div>
    <div>
      <div className="flex items-center gap-2 px-6 pt-6">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors border ${activeTab === tab.id
              ? "bg-indigo-500/20 text-indigo-300 border-indigo-500/40"
              : "text-slate-400 hover:text-white border-transparent"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "dashboard" ? (
        <Dashboard onNavigate={(page) => page === "opportunities" && setActiveTab("opportunities")} />
      ) : (
        <GovernmentOpportunities />
      )}
    </div>
  );
}

function DeadlineChip({ days }) {
  const critical = days <= 7;
  return (
    <span className={`inline-flex items-center gap-1 font-mono text-[11px] rounded-full px-2 py-0.5 border ${critical
      ? "border-red-500/25 bg-red-500/10 text-red-300"
      : "border-white/[0.06] bg-white/[0.02] text-white/60"
      }`}>
      <Calendar className="h-2.5 w-2.5" />
      {days}d left
    </span>
  );
}

function ScoreBar({ value }) {
  return (
    <div className="w-16 h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
      <div
        className="h-full rounded-full"
        style={{
          width: `${value}%`,
          background: "linear-gradient(90deg, #5E6AD2, #00E5FF)",
        }}
      />
    </div>
  );
}

function MiniCell({ label, value }) {
  return (
    <div className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-3">
      <div className="font-mono text-[10px] uppercase tracking-wider text-white/50">{label}</div>
      <div className="mt-1 font-mono text-[14px]">{value}</div>
    </div>
  );
}
